import {FormSection} from "../../../ui";
import {FieldInput} from "@kroschke/react-ui";
import {ReactNode} from "react";

export interface VdaDocumentDefaultFormData {
    vin: string
    documentId: string
    position: number
}

export interface VdaDocumentDefaultValidation {
    documentId?: string
    position?: string
}

export interface VdaDocumentDefaultBaseProps {
    label: string,
    disabled?: boolean
}

export interface VdaDocumentDefaultFormProps extends VdaDocumentDefaultBaseProps{
    validation: VdaDocumentDefaultValidation,
    value: VdaDocumentDefaultFormData
    onChange: (value: VdaDocumentDefaultFormData) => any
    onBlur: () => any
    header?: ReactNode
}


export function VdaDocumentDefaultForm({
                                       value,
                                       disabled,
                                       onChange,
                                       onBlur,
                                       validation,
                                       label,
                                        header
                                   }: VdaDocumentDefaultFormProps) {

    return <FormSection
        label={label}
        header={header}
        children={
            <>
                <div className={"columns"}>
                    <div className={"column is-one-third"}>
                        <FieldInput
                            disabled={true}
                            value={value.vin}
                            label={"Fahrgestellnummer"}
                        />
                    </div>
                    <div className={"column is-one-third"}>
                        <FieldInput
                            disabled={disabled}
                            label={"Dokumenten-Id"}
                            required={true}
                            help={validation.documentId}
                            invalid={Boolean(validation.documentId)}
                            value={value.documentId}
                            onBlur={() => !disabled && onBlur()}
                            onChange={documentID => {
                                onChange({
                                    ...value,
                                    documentId: documentID
                                })
                            }}
                        />
                    </div>
                    <div className={"column is-one-third"}>
                        <FieldInput
                            disabled={disabled}
                            label={"Position"}
                            required={true}
                            help={validation.position}
                            invalid={Boolean(validation.position)}
                            value={`${value.position}`}
                            onBlur={() => !disabled && onBlur()}
                            onChange={position => {
                                onChange({
                                    ...value,
                                    position: parseInt(position) || 0
                                })
                            }}
                        />
                    </div>
                </div>
            </>
        }
    />
}